import { useParsedQuery } from '@/hooks/useParsedQuery'
import { DATE_FORMAT } from '@/utils/consts'
import dayjs from 'dayjs'
import { OutboundSchedulePageQueryParams, OutboundScheduleShipperCode } from '../types/query'
import { useScheduleShipperCode } from '../context/ScheduleShipperContext'

/**
 *  조회 일자 (화주사 코드 없음)
 *  - 쿼리 파라미터 없으면 오늘 날짜 반환
 *  - 이전날짜도 같이 제공
 *  - ScheduleShipperProvider 밖(index.tsx 헤더)에서도 쓸 수 있다
 */
export const useCutOffDateOnly = (): { cutOffDate: string; prevCutOffDate: string } => {
  const { parsedQs } = useParsedQuery<OutboundSchedulePageQueryParams>()

  if (parsedQs.date) {
    return {
      cutOffDate: parsedQs.date,
      prevCutOffDate: dayjs(parsedQs.date).subtract(1, 'day').format(DATE_FORMAT.date),
    }
  }

  const cutOffDate = dayjs().format(DATE_FORMAT.date)

  return {
    cutOffDate,
    prevCutOffDate: dayjs(cutOffDate).subtract(1, 'day').format(DATE_FORMAT.date),
  }
}

/**
 *  조회 일자 + 화주사 코드
 *  - 화주사 코드는 허용 화주로 확정된 값만 쓴다 (LOGISPRD-12495) — ScheduleShipperProvider 안에서만 호출
 */
export const useCutOffDate = (): { cutOffDate: string; prevCutOffDate: string; shipperCode: OutboundScheduleShipperCode } => {
  const { cutOffDate, prevCutOffDate } = useCutOffDateOnly()
  const shipperCode = useScheduleShipperCode()

  return { cutOffDate, prevCutOffDate, shipperCode }
}
